import React from 'react';

import { styled } from '@mui/material/styles';
import classnames from 'classnames';


const Container = styled('section')`
  background-color: white;  
  display: flex;
  justify-content: center;

  iframe {
    border: 0;
  }
`;

type Props = {
  className?: string;
};

const Map = ({ className }: Props) => (
  <Container className={classnames('Map', className)}>
    <iframe title='Coastal Cement LLC Map' src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13200.287772087891!2d-77.945626!3d34.1956382!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89aa1f2077aeafed%3A0x339615e5ab77191d!2sCoastal%20Cement%2C%20LLC!5e0!3m2!1sen!2sus!4v1710291678838!5m2!1sen!2sus" width="600" height="450" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
  </Container>
);

export default Map;